import { useMutation } from '@tanstack/react-query';

import { downloadSignedFile } from '@services/document-signer/document-signer.service';

export function useDownloadDocument(accessToken: string) {
  return useMutation({
    mutationFn: (fileId: string) => downloadSignedFile(fileId, accessToken),
    onSuccess: (blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'documento_assinado.pdf';
      link.click();
      URL.revokeObjectURL(link.href);
    },
  });
}
